import React from 'react';
import { Offers } from './blocks';
import { OfferDetailsData } from '@/pages/hettwer/types/OfferDetailsData.ts';


interface OffersContentProps {
  offers: OfferDetailsData[];
  loading: boolean;
  on_delete: (offerId: string) => void;
}

const OffersContent: React.FC<OffersContentProps> = ({ offers, loading, on_delete }) => {
  return (
    <div>
      <Offers offers={offers} loading={loading} on_delete={on_delete} />
    </div>
  );
};

export { OffersContent };
